<!-- AnalisisDashboard.vue -->
<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="fw-bold text-primary">
        <font-awesome-icon icon="flask" class="me-2" />
        Gestión de Análisis de Calidad
      </h3>
    </div>

    <!-- Botonera de pestañas -->
    <div class="mb-3 d-flex gap-2">
      <button
        class="btn btn-outline-primary"
        :class="{ active: vista === 'list' }"
        @click="vista = 'list'"
      >
        📋 Listado
      </button>
      <button
        class="btn btn-outline-primary"
        :class="{ active: vista === 'detalle' }"
        @click="vista = 'detalle'"
      >
        🔍 Detalle
      </button>
      <button
        class="btn btn-outline-primary"
        :class="{ active: vista === 'tipos' }"
        @click="vista = 'tipos'"
      >
        ⚙️ Tipos de Análisis
      </button>
    </div>

    <!-- Contenido de vistas -->
    <div v-if="vista === 'list'">
      <AnalisisList
        @crear="mostrarCrear"
        @editar="mostrarEditar"
        @ver="verAnalisis"
      />
    </div>
    <div v-else-if="vista === 'form'">
      <AnalisisForm
        :analisis="analisisSeleccionado"
        @cancelar="resetFormulario"
        @guardado="onGuardado"
        class="mt-4"
      />
    </div>
    <div v-else-if="vista === 'detalle'">
      <AnalisisDetalle
        v-if="analisisDetalle"
        :id="analisisDetalle"
        @cerrar="analisisDetalle = null"
      />
      <div v-else class="text-muted">Seleccione un análisis para ver el detalle.</div>
    </div>
    <div v-else-if="vista === 'tipos'">
      <TipoAnalisisAdmin />
    </div>
  </div>
</template>

<script>
import AnalisisList from '@/components/Analisis/AnalisisList.vue'
import AnalisisForm from '@/components/Analisis/AnalisisForm.vue'
import AnalisisDetalle from '@/components/Analisis/AnalisisDetalle.vue'
import TipoAnalisisAdmin from '@/components/Analisis/TipoAnalisisAdmin.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'AnalisisDashboard',
  components: {
    AnalisisList,
    AnalisisForm,
    AnalisisDetalle,
    TipoAnalisisAdmin,
    FontAwesomeIcon
  },
  data() {
    return {
      analisisSeleccionado: null,
      analisisDetalle: null,
      vista: 'list' // 'list', 'form', 'detalle', 'tipos'
    }
  },
  methods: {
    verAnalisis(id) {
      this.analisisDetalle = id
      this.vista = 'detalle'
    },
    onGuardado() {
      this.resetFormulario()
    },
    resetFormulario() {
      this.vista = 'list'
      this.analisisSeleccionado = null
    },
    mostrarCrear() {
      this.vista = 'form'
      this.analisisSeleccionado = null
    },
    mostrarEditar(analisis) {
      this.vista = 'form'
      this.analisisSeleccionado = analisis
    },
    irAListado() {
      this.vista = 'list'
    },
    irADetalle() {
      this.vista = 'detalle'
    },
    irATipos() {
      this.vista = 'tipos'
    }
  }
}
</script>

<style scoped>
.btn.active, .btn:active {
  background-color: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}
</style>
